import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["arrow", "children", "hasFluidWidth", "inverse", "id", "isNotText", "testID", "UNSAFE_tooltipProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import View from '@bubble-ui/primitive-view';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Text from '@bubble-ui/primitive-text';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useDesignContext } from '@klarna/designtokens';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var Tooltip = _ref => {
  var {
      arrow,
      children,
      hasFluidWidth,
      inverse,
      id,
      isNotText,
      testID,
      UNSAFE_tooltipProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'Tooltip',
    props,
    useInstead: 'UNSAFE_tooltipProps',
    removalDate: 'v7.0.0'
  });
  var ids = getIds(id);
  var designContext = useDesignContext(defaultDesignTokens);
  var designVersion = useDesignVersion();
  var {
    mainStyle,
    arrowContainerStyle,
    arrowRotatorStyle,
    arrowBackgroundColor,
    arrowBorderColor,
    backgroundStyle,
    textStyle
    // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
    // Keep passing all props to the style sheet, even if we don't use them ourselves
  } = useStyleSheet(Tooltip, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    arrow,
    children,
    designContext,
    designVersion,
    hasFluidWidth,
    inverse,
    id,
    isNotText,
    testID,
    UNSAFE_tooltipProps
  }));
  return /*#__PURE__*/React.createElement(View, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.root,
    testID: testID
  }, UNSAFE_tooltipProps, {
    style: mainStyle
  }, props), arrow && /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.arrowContainer,
    style: arrowContainerStyle
  }, /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.arrowRotator,
    style: arrowRotatorStyle
  }, /*#__PURE__*/React.createElement(Surface, {
    width: 25,
    height: 11
  }, /*#__PURE__*/React.createElement(Shape, {
    d: "M0,0 L0,0 L10,10 L20,0",
    stroke: arrowBorderColor,
    fill: arrowBackgroundColor
  })))), /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.background,
    style: backgroundStyle
  }, isNotText && typeof children !== 'string' ? children : /*#__PURE__*/React.createElement(Text, {
    numberOfLines: 0,
    tag: "paragraph",
    id: ids === null || ids === void 0 ? void 0 : ids.text,
    style: _objectSpread({}, textStyle)
  }, children)));
};
Tooltip.displayName = 'Tooltip';

/**
 * @talebook https://bubble-ui.klarna.net/#components/tooltip
 */
export default withProvisionalOverrideFromContext(Tooltip);

/**
 * @deprecated v6.0.0
 */
//# sourceMappingURL=index.js.map